import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
 
import * as headerActions from '../../../actions/headerActions.js';
import MDTHeaderToolbar from './header-toolbar/headerToolbar.js';

export const MDTNavigation = (props) => {
  return (
 
      <Fragment>
        <MDTHeaderToolbar {...props} /> 
      </Fragment>
  
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(headerActions, dispatch),
  };
};

export default connect(mapDispatchToProps)(MDTNavigation);
